<div [formGroup]="formGroupBuilderInput" style="background-color: lightgoldenrodyellow;">

    <ng-container *ngFor="let element of formConfigObjectInput">
        <hr />
        <div><i>{{element | json}}</i></div>

        <ng-container *ngIf="element.picklist != null">
            <mat-form-field class="formItem" *ngIf="Picklist != undefined">
                <mat-label>{{element.formControlName}}
                </mat-label>
                <!-- (ngModelChange)="element.function != null || element.function != undefined ? onSubmit(element.function) : null" -->
                <mat-select [formControlName]="element.formControlName" [required]="element.required">
                    <mat-option *ngFor="let project of Picklist[element.picklist]"
                        [value]="fromPicklist.transform(project.text, Picklist[element.picklist])">
                        {{project.text}}
                    </mat-option>
                </mat-select>
                <mat-error>{{element.formControlName}} is required</mat-error>
            </mat-form-field>

            <i>toPicklist.transform: </i>
            <b>{{toPicklist.transform(formGroupBuilderInput.value[element.formControlName], Picklist[element.picklist])}}</b>
            <br>
        </ng-container>

        <ng-container *ngIf="element.textArea != null">
            <mat-form-field class="formItem" appearance="outline">
                <mat-label>{{element.formControlName}}</mat-label>
                <textarea matInput type="text" [formControlName]="element.formControlName" [required]="element.required">
            </textarea>
            </mat-form-field>
        </ng-container>

        <ng-container *ngIf="element.button != null">
            <button mat-raised-button class="StandardButton" type="submit"
                (click)="element.function ? onSubmit(element.function) : null">{{"Submit"}}</button>
        </ng-container>
    </ng-container>


    <pre>{{formGroupBuilderInput.value | json}}</pre>

</div>